<template>
    <div class="flex flex-col items-center border bg-grey-lightest p-6" :class="{
        'md:flex-row md:text-left md:px-6': ! mobile,
    }">
        <img src="/img/apiro-question.gif" alt="Apiro has a question" class="w-32" />
        <div class="flex-1 text-center  " :class="{
            'md:flex-row md:text-left md:px-6': ! mobile,
        }">
            <h3>Not sure what's right for you?</h3>
            <p>This can all be pretty confusing. However we're only just a click away and can help you make the right decision by talking to our 24/7 Sales &amp; Support Staff.</p>
        </div>
        <div class="w-full" :class="{
            'md:w-auto': ! mobile,
        }">
            <!-- <button class="btn btn-primary w-full px-12 block" @click="openChat()" :class="{
                'md:inline-block': ! mobile,
            }">Lets Talk</button> -->
        </div>
    </div>
</template>

<script>
export default {
    props: {
        mobile: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
